import React, { FC, memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFilters } from '@hooks/useFilters';
import { useFilterBuilder } from '@hooks/useFilterBuilder';
import { Typography, TypographyAppearanceVariants } from '@components/atoms/Typography';
import { RadioFilter } from '../RadioFilter';

export const FavoriteFilter: FC = memo(() => {
    const { appliedFilters, setFilterValues } = useFilters();
    const { t } = useTranslation();

    const translations = {
        title: t('filter-favorites.title'),
        favoriteOnly: t('filter-favorites.favorite-only'),
        all: t('filter-favorites.all'),
    };

    const paramName = 'favorites';
    const title = translations.title;

    const { getOptions, setOnlyValue } = useFilterBuilder([
        {
            paramName,
            labelField: 'name',
            data: {
                data: [
                    { name: translations.favoriteOnly, uuid: 'favorite-only' },
                    { name: translations.all, uuid: 'all' },
                ],
            },
            requestData: null,
            appliedValues: appliedFilters.find((item) => item.label === title)?.values.map((value) => value.name) || [],
            setFilterValues: (data) => setFilterValues(title, data),
        },
    ]);

    const options = getOptions(paramName);

    // default select radio 'all'
    useEffect(() => {
        const hasChecked = options.some((option: any) => option.checked);

        if (options.length > 0 && !hasChecked) {
            setOnlyValue(paramName, 'all');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options]);

    return (
        <div className="pt-2">
            <Typography classes="mb-2" appearanceLevel={TypographyAppearanceVariants.level7}>
                {title}
            </Typography>
            <hr />
            <RadioFilter
                options={options.map((option: any) => {
                    return { ...option, onClick: () => setOnlyValue(paramName, option.uuid) };
                })}
            />
        </div>
    );
});
